import { stringify } from 'qs';
import {URL_API} from "../../url.config";
import {request} from "../../utils/apiUtils";
let DepartmentController = {
    getList: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/department/list`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/department/create`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/department/edit`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/department/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/department/delete/${id}`,
            method: 'GET'
        }, callback)
    },
}
export default DepartmentController
